import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { State } from "../types/common/State";
import menuItems from "../db/menuItems";
import { DefaultRoutesAccessLevel } from "../enums/DefaultRouteAccessLevel";
import { ProtectedRouteProps } from "../types/routes/ProtectedRouteProps";
import { RoleChange } from "../components/Modals/RoleChange/RoleChange";
import Cookie from "../services/Cookies";

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { i18n } = useTranslation();
  const role = useSelector((state: State) => state.userInfo?.accessLevel) ?? 0;
  const lang = useSelector((state: State) => state.userInfo?.defaultLanguage) ?? "es";
  const userMenu = useSelector((state: State) => state.menu);
  const isMultiRole = useSelector((state: State) => state.userInfo?.hasMultiRol) ?? false;
  const tdb_showMultiRole = Cookie.get("tdb_showMultiRole");
  let location = useLocation();
  let shouldAccess = false,
    redirect = '';

  const checkAccess = (path: string) => {
    if (location.pathname === path) {
      shouldAccess = true;
    } else {
      redirect = path;
    }
  };

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  menuItems.forEach((nav, idx) => {
    if (userMenu.includes(nav.name)) {
      if(nav.path === location.pathname) {
        shouldAccess = true;
      }
      else checkAccess(DefaultRoutesAccessLevel.get(role) ?? '');
    }
  });

  if (!shouldAccess) {
    return <Navigate to={redirect} />;
  }

  return (
    <>
      {isMultiRole && tdb_showMultiRole && (
        <RoleChange />
      )}
      {children}
    </>);
};

export default ProtectedRoute;
